import { Component } from '@angular/core';
import { TranslatePipe } from '../languages/translate.pipe';

@Component({
  selector: 'app-credits',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './credits.component.html',
  styleUrl: './credits.component.css',
})
export class CreditsComponent {}
